module.exports = __webpack_public_path__ + "static/media/uploadTemplate.b54c50b1.csv";